import React, { useEffect, useState } from "react";
import "../../css/conversation.css";
import { SuccessAlert } from "../successAlert";
import ContactInfo from "../callQueue/elements/sections/contactInfo";
import HomeInfo from "../callQueue/elements/sections/homeInfo";
import DispositionBlock from "../callQueue/elements/sections/dispositions";
import LeadCardTopBar from "../callQueue/elements/sections/leadCardTopBar";
//import { removeTagFromLead } from '../../utilities/tagFunctions';
import { fetchWithDefaults } from "../../config/fetchDefault";
import { useSelector, useDispatch } from "react-redux";
import Qualifier from "../qualifier/qualifier";
import EditEvent from "../callQueue/elements/sections/editEvent";
import AddEvent from "../callQueue/elements/sections/addEvent";
import AdditionalInfo from "../callQueue/elements/sections/additionalInfo";
import LeadCardHeader from "../leads/leadCardHeader";
import { leadCardTabOptions, updateLeadInfo } from "../../utilities/leadFunctions";
import { fetchActivityThunk } from "../../features/scheduledCallSlice";
import {CallBlockedErrorModal, CallBlockedError, InvalidNumberErrorMsg, InvalidNumberErrorModal, MicPermissionError, MicPermissionErrorModal, TwilioCallErrorMessage, TwilioCallErrorModal} from "./tMobileError";
import { setMicPermissionError, setMicPermissionModalLocked } from "../../features/callPermissionErrorSlice";
import DoNotContact from "./DoNotContact";
import { callErrorTypes, resetCallError } from "../../features/callSlice";

function LeadData({
  from,
  setApptSet,
  handleSetScripting,
  permission,
  setScripting,
  qualifier,
  selectTab,
  setResults,
  makeDial,
  handleLeadData,
  setNewAppt,
  newAppt,
  profile,
  setProfile,
  possibleConditions,
  setPossibleConditions,
  openViaDial = false,
  maxList
}) {

  const dispatch = useDispatch();
  const queue = useSelector((state) => state.queue.queue);
  const backUp = useSelector((state) => state.queue.originalQueue);
  const agentId = useSelector((state) => state.agent.userData).agentId;
  const agentInfo = useSelector((state) => state.agent.userData);
  // ===== leads popup full data =====
  const leadsAlldata = useSelector(
    (state) => state.leadAllDataInfo?.leadsAllInfoData
  );
  const micPermissionError = useSelector(state => state.micpermissions.micPermissionError);
  const hasTriedMicPermission = useSelector(state => state.micpermissions.hasTriedMicPermission);
  const micPermissionModalLocked = useSelector(state => state.micpermissions.micPermissionModalLocked);
  const hasTriggeredMicModal = useSelector(state => state.micpermissions.hasTriggeredMicModal);


  const [isLeadNumberInValid,setisLeadNumberInValid] = useState(false)
  //const [successTrigger, setSuccessTrigger] = useState(false);
  const [update, setUpdate] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  //const [qualifier, setQualifier] = useState(false);
  const [calendar, setCalendar] = useState(false);
  const [newEvent, setNewEvent] = useState(false);
  const [date, setDate] = useState(false);
  const [time, setTime] = useState(false);
  const [event, setEvent] = useState(false);

  const newEventPackage = [
    { setNewEvent: setNewEvent, setTime: setTime, setDate: setDate },
  ];

  const calendarUsing = async (id) => {
    setCalendar(id);
  };
  const handleSetQualifier = (link) => {
    selectTab(leadCardTabOptions.QUOTE);
    setScripting(true);
    //  handleScriptType('qual')
  };

  const handleClose =()=>{
    dispatch(resetCallError())
  };
  const handleCloseMicErr = () => {
    dispatch(setMicPermissionError(false));
  };
  const handleCloseMicErrModal = () => {
   dispatch(setMicPermissionModalLocked(false));
  };

  const setAppointment = async (event, video) => {
    try {
      const requestOptions = leadsAlldata?.lead_id && {
        method: "POST",
        body: JSON.stringify({
          agent: agentId,
          team: agentInfo.teamId,
          leadId: leadsAlldata.lead_id,
          event: event,
          video: video,
        }),
      };

      const response = await fetchWithDefaults(
        "/google/create/event",
        requestOptions
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const jsonData = await response.json();

      if (response.ok) {
        dispatch(fetchActivityThunk({ agentIdNumber: agentInfo.agentId }));
      }
      setNewAppt(jsonData.event);
      setNewEvent(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const addTag = (tag) => {
    //addTagToLead(setSelectedTags, selectedTags, tag);
    let tags;
    if (selectedTags.length > 0) {
      tags = [selectedTags[0], tag];
    } else {
      tags = [tag];
    }

    //setSelectedTags([...selectedTags, tag]);
    const newarr = [...selectedTags, tag];

    handleLeadData("tag_ids", newarr[0]);
    const formattedString = tags
      .map((item) => `${item.id}*${item.name}`)
      .join(",");

    updateLeadInfo(
      queue,
      "tag_ids",
      formattedString,
      leadsAlldata.lead_id,
      dispatch,
      "queue"
    );
    updateLeadInfo(
      backUp,
      "tag_ids",
      formattedString,
      leadsAlldata.lead_id,
      dispatch,
      "backup"
    );
  };

  const handleNumberMsgClose =()=>{
    setisLeadNumberInValid(false);
  };

  const {callErrorType, callErrorMessage, callErrorSolutions} = useSelector(state => state.call)

  return (
    leadsAlldata && (
      <div className="quilityParentBlockContent leadCardContentAdjustment">
        {
          //<SuccessAlert message={'Status Changed'} setSuccessTrigger={setSuccessTrigger} successTrigger={successTrigger}/>
        }
        {callErrorType !== callErrorTypes.NONE && !micPermissionError && !openViaDial && (
            <TwilioCallErrorMessage
                handleClose={handleClose}
                errorMessage={callErrorMessage}
                errorSolutions={callErrorSolutions}
            />
        )}
         {micPermissionError && hasTriedMicPermission && callErrorType === callErrorTypes.NONE &&(
          <MicPermissionError handleClose={handleCloseMicErr}/>
        )}
        {isLeadNumberInValid && !openViaDial &&(
          <InvalidNumberErrorMsg handleClose={handleNumberMsgClose}/>
        )}
        <span style={{ textAlign: "left" }}>
          <LeadCardHeader />
          <DoNotContact maxList={maxList}/>
          <LeadCardTopBar
            newEvent={newEvent}
            setApptSet={setApptSet}
            from={from}
            update={update}
            handleSetScripting={handleSetScripting}
            setQualifier={handleSetQualifier}
            qualifier={qualifier}
            calendarUsing={calendarUsing}
            newAppt={newAppt}
            setNewAppt={setNewAppt}
            newEventPackage={newEventPackage}
            setEvent={setEvent}
          />
        </span>
        <div className="leadInfoWrapper">
          {leadsAlldata &&
            (qualifier ? (
              <Qualifier
                possibleConditions={possibleConditions}
                setPossibleConditions={setPossibleConditions}
                setProfile={setProfile}
                profile={profile}
                setResults={setResults}
                handleLeadData={handleLeadData}
                handleSetQualifier={handleSetQualifier}
                agentId={agentId}
              />
            ) : (
              <>
                {!permission && (
                  <ContactInfo
                    handleLeadData={handleLeadData}
                    makeDial={makeDial}
                    setisLeadNumberInValid={setisLeadNumberInValid}
                  />
                )}
                {leadsAlldata["custom_fields"] && <AdditionalInfo />}
                <HomeInfo handleLeadData={handleLeadData} />
              </>
            ))}
          {event && (
            <EditEvent
              from={from}
              setUpdate={setUpdate}
              setEvent={setEvent}
              calendar={calendar}
              event={event}
            />
          )}
          {newEvent && (
            <AddEvent
              from={from}
              setAppointment={setAppointment}
              calendar={calendar}
              setNewEvent={setNewEvent}
              agentTimezone={agentInfo.timezone}
              date={date}
              time={time}
            />
          )}
        </div>
        {
          openViaDial && callErrorType !== callErrorTypes.NONE &&
            <TwilioCallErrorModal
                handleClose={handleClose}
                errorMessage={callErrorMessage}
                errorSolutions={callErrorSolutions}
            />
        }
        {
          hasTriggeredMicModal && micPermissionModalLocked &&
          <MicPermissionErrorModal handleClose={handleCloseMicErrModal}/>
        }
        {isLeadNumberInValid && openViaDial &&(
          <InvalidNumberErrorModal handleClose={handleNumberMsgClose} />
        )}
      </div>
    )
  );
}

export default LeadData;
